import Vue from 'vue';
import Vuetify from "vuetify"; 
import Modal from './modal.vue';

Modal.newInstance = properties => {
    const {render, ...other} = properties || {};
    const Instance = new Vue({
        vuetify: new Vuetify(),
        data: Object.assign({
            visible: false,
            showCancel:false,
            title:'',
            icon:'',
            modal_type: '',
            icon_color: '',
        }, other),
        computed: {
        },
        methods: {
            cancel() {
                if (this.modal_type === 'confirm' && this.onCancel) {
                    this.onCancel()
                    this.destroy()
                    return
                }
               this.destroy()
            },
            ok(stopLoading) {
                if (this.onOk) {
                    const callParams = {}
                    if (stopLoading) {
                        callParams.stopLoading = stopLoading
                    }
                    callParams.destroy = this.destroy
                    this.onOk(callParams)
                    if (!this.loading) {
                        this.destroy()   
                    }
                    return
                }
                this.destroy()
            },
            destroy() {
                this.visible = false
                setTimeout(() => {
                    this.$destroy()
                }, 500)
            },
        },
        render(h) {
            const _this = this
            return h(Modal, {
                    props:  {
                        showCancel:this.showCancel,
                        title:this.title,
                        icon: this.icon,
                        visible: this.visible,
                        modal_type: this.modal_type,
                        icon_color: this.icon_color,
                        width: this.width,
                        okText: this.okText,
                        cancelText: this.cancelText,
                        content: this.content,
                        loading: this.loading,
                        closable: this.closable,
                        render: render
                    },
                    on: {
                        cancel:_this.cancel,
                        ok:_this.ok
                    }
            });
        }
    });
    const component = Instance.$mount();

    return {
        show(props) {
            Object.keys(props).forEach(key => {
             if (key === 'render') {
                return
             }
             component[key] = props[key]
            })
        },
    };
};

export default Modal;
